export default __webpack_public_path__ + "static/media/vitrages.41cfce9d.png";